<template>
  <div :class="{dark:$vuetify.theme.dark}">
    <div
      v-if="single"
      class="singleWrap"
      @click="handleCliekUpload"
    >
      <v-layout
        v-if="uploading"
        column
        align-center
        justify-center
        style="height: 100%"
      >
        <v-progress-circular
          indeterminate
          small
          color="primary"
        />
      </v-layout>
      <div
        v-else-if="uploadList.length"
        :style="{backgroundImage: `url(${$options.filters.upyun(uploadList[0].url, '!/fh/150')})`}"
        class="singlePreview"
      />
      <v-layout
        v-else
        column
        align-center
        justify-center
        style="height: 100%"
      >
        <slot name="updateText" />
        <v-icon
          v-if="!$slots.updateText"
          style="font-size: 70px;opacity: 0.5;"
          class="grey--text"
        >
          insert_photo
        </v-icon>
        <div style="font-size: 16px;">
          點擊上傳
        </div>
      </v-layout>
    </div>
    <v-btn
      v-else
      :loading="uploading"
      text
      color="info"
      @click="handleCliekUpload"
    >
      <v-icon class="mr-2">
        insert_photo
      </v-icon>
      {{ label || '選擇圖片' }}
    </v-btn>
    <input
      ref="inputFileImage"
      :multiple="!single"
      type="file"
      style="display: none"
      accept="image/*"
      @change="onFilePicked"
    >

    <v-layout
      v-if="!single"
      row
      wrap
      class="ma-0 mt-4"
    >
      <div
        v-for="item in uploadList"
        :key="item.url"
        :style="{ width: imageWidth + 'px' }"
        class="imageItem mr-1 mb-1"
      >
        <v-card
          flat
          tile
        >
          <v-img
            :src="item.url | upyun('!/fh/150')"
            aspect-ratio="1"
            class="grey lighten-2"
          />
          <v-layout
            class="btns"
            row
            wrap
            justify-center
          >
            <!-- <v-icon @click="viewImage(item)">visibility</v-icon> -->
            <v-btn
              small
              class="info my-2"

              @click="deleteItem(item)"
            >
              <v-icon small>
                delete
              </v-icon>刪除
            </v-btn>
          </v-layout>
        </v-card>
      </div>
    </v-layout>

    <v-dialog
      v-model="showBigImage"
      width="1000"
    >
      <v-img
        v-if="bigImageSrc"
        :src="bigImageSrc.url | upyun()"
        class="grey lighten-2"
      />
    </v-dialog>
  </div>
</template>

<script>
import Compressor from 'compressorjs'

export default {
  props: {
    value: {
      require: true,
      type: Array
    },
    block: Boolean,
    max: {
      type: Number,
      default: 0 // 0 为不限制
    },
    imageWidth: {
      type: Number,
      default: 100
    },
    dir: {
      type: String,
      default: 'common'
    },
    ext: String,
    listenGlobalPaste: Boolean, // 不处理全局粘贴事件
    disabled: Boolean,
    single: Boolean,
    label: String,
    uploadFn: Function,
    hd: Boolean,
  },
  data () {
    return {
      uploadList: this.value,
      uploadHistory: [],
      uploading: false,
      droping: false,
      foucsing: false,
      showBigImage: false,
      bigImageSrc: ''
    }
  },
  watch: {
    value: {
      handler () {
        this.uploadList = this.value
      },
      immediate: true
    },
    uploadList () {
      this.$emit('input', this.uploadList)
    }
  },
  mounted () {
    // document.addEventListener('paste', this.onPaste)
    // this.$refs.updateArea.addEventListener('dragover', this.onDragover)
    // this.$refs.updateArea.addEventListener('dragleave', this.onDragleave)
    // this.$refs.updateArea.addEventListener('drop', this.onDrop)
  },
  beforeDestroy () {
    // document.removeEventListener('paste', this.onPaste)
    // this.$refs.updateArea.removeEventListener('dragover', this.onDragover)
    // this.$refs.updateArea.removeEventListener('dragleave', this.onDragleave)
    // this.$refs.updateArea.removeEventListener('drop', this.onDrop)
  },
  methods: {
    handleCliekUpload () {
      if (this.uploading) return
      this.$refs.inputFileImage.click()
    },
    deleteItem (item) {
      if (this.uploadHistory.indexOf(item) > -1) {
        if (!this.uploadFn) {
          this.$store.dispatch('upyun/delete', {
            path: item.url
          })
        }
      }
      this.uploadList.splice(this.uploadList.indexOf(item), 1)
    },
    onFilePicked (e) {
      if (e.target.files.length) {
        this.uploadFile([...e.target.files])
      }
    },
    viewImage (item) {
      this.showBigImage = true
      this.bigImageSrc = item
    },
    async uploadFile (files) {
      if (this.uploading) {
        return
      }
      this.uploading = true
      if (this.max > 0) {
        files = files.slice(0, this.max - this.uploadList.length)
      }
      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          await new Promise((resolve, reject) => {
            console.log('staret compressor file', file.name, file.size, file.type)
            // eslint-disable-next-line
            new Compressor(file, {
              quality: this.hd ? 0.92 : 0.8,
              maxWidth: this.hd ? 4000 : 1500,
              maxHeight: this.hd ? 4000 : 2000,
              minWidth: 100,
              minHeight: 100,
              success: (result) => {
                console.log('upload file', result.name, result.size, result.type)
                return new Promise((resolve) => {
                  if (this.uploadFn) {
                    return resolve(this.uploadFn(file))
                  }
                  resolve(this.$store.dispatch('upyun/uploadImg', {
                    file: result,
                    policyParams: {
                      dir: this.dir
                    }
                  }))
                }).then(({ data }) => {
                  if (this.single) {
                    this.uploadList = [data]
                  } else {
                    this.uploadList.push(data)
                  }
                  this.uploadHistory.push(data)
                  resolve()
                }).catch(e => {
                  console.error(e)
                  this.$snackbar(e.toString())
                  reject(new Error(e))
                })
              },
              error: (err) => {
                console.log(err)
                this.$snackbar(err.message)
                reject(new Error(err.message))
              },
            })
          })
          await this.$sleep(600)
        }
      } finally {
        this.uploading = false
        this.$refs.inputFileImage.value = null
      }
    },
    onPaste (e) {
      if (!this.foucsing && !this.listenGlobalPaste) {
        return
      }
      const file = [...e.clipboardData.items].find(item => item.type.indexOf('image') !== -1)
      if (!file) return

      this.uploadFile([file.getAsFile()])
    },
    onDragover (e) {
      e.preventDefault()
      this.droping = true
    },
    onDragleave (e) {
      e.preventDefault()
      this.droping = false
    },
    onDrop (e) {
      e.preventDefault()
      this.droping = false
      if (e.dataTransfer.files.length) {
        this.uploadFile([...e.dataTransfer.files])
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.imageItem {
}

.upload-wrap {
  text-align: center;
  width: 250px;
  border: 2px dashed transparent !important;
  position: relative;
  &.block{
    width: 100%;
  }
  &:focus {
    border: 2px dashed #f00 !important;
  }
  &.droping {
    border: 2px dashed #afacac !important;
  }

  .pasteInput {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    &:focus {
      outline-style: auto;
      outline-color: rgb(59, 153, 252);
    }
  }
}
.singleWrap {
    border-radius: 12px;
    border: 2px #b5b5b5 dashed !important;
    overflow: hidden;
    color: #b5b5b5;
    height: 130px;
    background: #eee;
    cursor: pointer;
    .singlePreview {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
    }
}
.dark {
  .singleWrap {
    background: none;
  }
}
</style>
